module.exports = __webpack_public_path__ + "img/tarj2-7.4114de2a.svg";